import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "wrapper1" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "com_mgb20 com_mgt100 com_fs26 com_medium1 com_center1" }, " 予期しないエラーが発生しました。 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "com_mgb50 com_reguler1 com_center1" }, [
  /*#__PURE__*/_createTextVNode(" 大変恐れ入りますが再度同じ手順を行って頂き、それでも正しく動作しない場合は"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 担当営業もしくはカウネットにお問い合わせください ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "com_copyright1 com_mgt100" }, "© 2025 Kaunet", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.logoImage,
      alt: _ctx.altText,
      class: "with-kaunet_logo-overtime"
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}